import { PropertySearchResTypeData } from '../../../../services/api';
import { FavoriteProperties } from '../../../../models/favorites.model.ts';
import { Box } from '@mui/material';
import { ResultsListItem } from '../../../../possibly-stateful-components/Results/ResultsListItem.tsx';

interface ResultsListProps {
  favoritesData: FavoriteProperties[];
  data: PropertySearchResTypeData[] | undefined;
}

export const ResultsList = ({ data, favoritesData }: ResultsListProps) => {
  return (
    <Box className="results-list">
      {data &&
        data.map((result: PropertySearchResTypeData) => (
          <Box key={result.id} sx={{ minWidth: '350px', maxWidth: '350px' }}>
            <ResultsListItem favorites={favoritesData} result={result} />
          </Box>
        ))}
    </Box>
  );
};
